module.exports = __webpack_public_path__ + "img/siemens_logo.7205839e.jpg";